import * as React from "react";
import { Checkbox } from "informed";
import { TimePicker } from "../../forms/informedv2/TimePicker";
import FailureWithMessage from "../../misc/components/FailureWithMessage";
import { DiarySessionFlow } from "./DiarySessionFlow/DiarySessionFlow";
import { Study } from "webportalclient";
import { useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";

interface EDiarySessionConfigurationProps {
    study: Study;
}

export const EDiarySessionConfiguration = ({ study }: EDiarySessionConfigurationProps) => {
    const [questionnaires, setQuestionnaires] = React.useState([]);
    const [complianceRules, setComplianceRules] = React.useState([]);
    const [alertRules, setAlertRules] = React.useState([]);
    const [transmissionMethods, setTransmissionMethods] = React.useState([]);
    const [failedToLoad, setFailedToLoad] = React.useState<string>();
    const legacyClient = useWebPortalLegacyClient();

    React.useEffect(() => {
        const getConfiguration = async () => {
            try {
                const elementsResult = await legacyClient.getConfigurationElements(study.id);

                setQuestionnaires(
                    Object.keys(elementsResult.Questionnaires).map(k => ({
                        Key: k,
                        Name: elementsResult.Questionnaires[k]
                    }))
                );

                setComplianceRules(
                    Object.keys(elementsResult.ComplianceRules).map(k => ({
                        Key: k,
                        Name: elementsResult.ComplianceRules[k]
                    }))
                );

                setAlertRules(
                    Object.keys(elementsResult.AlertRules).map(k => ({
                        Key: k,
                        Name: elementsResult.AlertRules[k]
                    }))
                );

                setTransmissionMethods(
                    Object.keys(elementsResult.TransmissionMethods).map(k => ({
                        Key: k,
                        Name: elementsResult.TransmissionMethods[k]
                    }))
                );
            } catch (err) {
                setFailedToLoad(
                    "The e-Diary configuration cannot be loaded for the study please ensure there is a configuration file associated to the study"
                );
            }
        };

        getConfiguration();
    }, []);

    if (failedToLoad) return <FailureWithMessage message={failedToLoad} />;

    return (
        <>
            <div className="row">
                <div className="form-group col-md-6">
                    <TimePicker
                        id="StartWindow"
                        field="StartWindow"
                        label="Time Window Start Time"
                        required={true}
                        placeholderText="HH:mm:ss (24 hour format)"
                        dateFormat="HH:mm:ss"
                        step={1}
                    />
                </div>
                <div className="form-group col-md-6">
                    <TimePicker
                        id="EndWindow"
                        field="EndWindow"
                        label="Time Window End Time"
                        required={true}
                        placeholderText="HH:mm:ss (24 hour format)"
                        dateFormat="HH:mm:ss"
                        step={1}
                    />
                </div>
            </div>

            <div className="row">
                <div className="form-group col-md-12">
                    <label htmlFor="ResetDiaryOnUpload">Reset Diary on USB upload</label>
                    <p className="help-block">Whether the Diary should be reset to blank when this session is uploaded via USB</p>
                    <Checkbox id="ResetDiaryOnUpload" field="ResetDiaryOnUpload" />&nbsp;
                </div>
            </div>

            <DiarySessionFlow questionnaires={questionnaires} alertRules={alertRules} complianceRules={complianceRules} transmissionMethods={transmissionMethods} />
        </>
    );
};
